export default __webpack_public_path__ + "static/media/logo-scaniaforum.77d6c7f8.png";